// export function numberWithCommas(x) {
window.numberWithCommas = function (x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

// export function allWhiteSpaces(string){
window.allWhiteSpaces = function (string) {
  if ($.trim(string) == '') {
    return true;
  } else {
    return false;
  }
}

window.removeLeadingZeros = function (string) {
  while (string.charAt(0) == '0') {            // Assume we remove all leading zeros
    if (string.length == 1) { break };       //But not final one.
    if (string.charAt(1) == '.') { break };  //Nor one followed by '.'
    string = string.substr(1, string.length - 1)
  }

  return string;
}

toastr.options = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": false,
  "progressBar": false,
  "positionClass": "toast-top-center",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
}


window.clearNotification = function () {
  toastr.remove();
}

window.toastNotification = function (type, message) {
  clearNotification();
  toastr[type](message);
}

window.removeCommas = function (string) {
  if (string == undefined) return
  return string.replace(/\,/g, "");
}

String.prototype.format = function () {
  var args = arguments;
  return this.replace(/\{\{|\}\}|\{(\d+)\}/g, function (m, n) {
    if (m == "{{") { return "{"; }
    if (m == "}}") { return "}"; }
    return args[n];
  });
};

/*
js> '{0} {{0}} {{{0}}} {1} {2}'.format(3.14, 'a{2}bc', 'foo');
     3.14 {0} {3.14} a{2}bc foo
*/

window.checkAmount = function (amountInput, amountInputDiv) {
  amount_checker(amountInput, amountInputDiv)
  $(amountInput).keyup(function (e) {
    if (e.keyCode != 13) {
      clearNotification();
    }

    amount_checker(amountInput, amountInputDiv)
  });

}

window.amount_checker = function (amountInput, amountInputDiv) {
  var amount = $(amountInput).val();
  amount = removeCommas(amount);

  if (amount == undefined) {
    return
  }

  if (isNaN(amount)) {
    $(amountInputDiv).removeClass('has-success');
    $(amountInputDiv).addClass('has-error');
    toastNotification('error', 'amount is not a proper number');
  } else {
    $(amountInputDiv).removeClass('has-error');
    $(amountInputDiv).addClass('has-success');
    amount = numberWithCommas(amount);
    $(amountInput).val(amount);
  }

  if (allWhiteSpaces(amount)) {
    $(amountInputDiv).removeClass('has-error');
    $(amountInputDiv).removeClass('has-success');
  }
}

window.isEmpty = function (value) {
  return typeof value == 'string' && !value.trim() || typeof value == 'undefined' || value === null;
}

// window.setUpInputValidations = function(input) {
//   $(input).keyup(function(e) {
//     if (!isEmpty($(e.target).val())){
//       $(e.target).removeClass("is-invalid form-control")
//     }
//   });
// }

window.setStockQuantity = function (selectID, qtyDivID) {
  const currentStock = $(`${selectID} option:selected`).data('balance')

  const quantityEl = $(qtyDivID)
  quantityEl.empty()
  quantityEl.text(`Current Stock:   ${numberWithCommas(currentStock)}`)

}

window.getProductQuantity = function (isSmall = false) {
  let productQuantityID = '#product-quantity'

  if (isSmall) {
    productQuantityID = '#product-quantity-sm'
  }

  return removeCommas($(productQuantityID).val())
}

window.storeItemInLocalStorage = function (singleItem, storageKey) {
  const ItemData = JSON.parse(localStorage.getItem(storageKey))

  // const itemKey = `${singleItem.code_id}-${singleItem.first_serial_number}-${singleItem.last_serial_number}`
  const itemKey = singleItem.key

  if (ItemData === null) {

    const data = {
      [itemKey]: singleItem
    }

    localStorage.setItem(storageKey, JSON.stringify(data))
  } else {
    ItemData[itemKey] = singleItem

    localStorage.setItem(storageKey, JSON.stringify(ItemData))
  }

  // console.log(JSON.parse(localStorage.getItem(storageKey)))
}

window.removeItemFromLocalStorage = function (itemKey, storageKey) {
  const data = JSON.parse(localStorage.getItem(storageKey))

  if (data === null) {
    console.log('ERROR')
    return
  } else {
    delete data[itemKey]

    localStorage.setItem(storageKey, JSON.stringify(data))
  }
}

window.uniqueKey = function (codeId, firstSerial, lastSerialNumber) {
  return String(codeId + '-' + firstSerial + '-' + lastSerialNumber)
}

window.paymentOptionsKey = function () {
  return 'payment-options'
}

window.removePaymentOptionData = function () {
  localStorage.removeItem(paymentOptionsKey())
}

window.getPaymentOptionsStorage = function () {
  return JSON.parse(localStorage.getItem(paymentOptionsKey()))
}

// window.removeLeadingZeros = function(num){
//   return num.replace(/^0+/, '');
// }

window.areSerialNumbersValid = function (firstSerialNumber, lastSerialNumber) {
  const firstNo = removeLeadingZeros(firstSerialNumber)
  const lastNo = removeLeadingZeros(lastSerialNumber)

  const twoOrMoreDigits = firstNo.length > 0 && lastNo.length > 0
  const areNotBlank = !(isNaN(firstNo) || allWhiteSpaces(firstNo) || isNaN(lastNo) || allWhiteSpaces(lastNo))
  const lastNoIsGreater = parseInt(lastNo) > parseInt(firstNo)


  return twoOrMoreDigits && areNotBlank && lastNoIsGreater
}

window.clearDisabledSubmit = function () {
  $('#submit-ajax-form-btn').prop("disabled", false)
}

window.disableSubmit = function () {
  $('#submit-ajax-form-btn').prop("disabled", true)
}

window.clearFailedSubmit = function (formId) {

  $('#select-payment-options').click(function () {
    clearDisabledSubmit()
  })

  $(formId).on('input', 'input', function (e) {
    clearDisabledSubmit()
  })

  $(formId).on('click', 'input', function (e) {
    clearDisabledSubmit()
  })

  $(formId).on('input', 'textarea', function (e) {
    clearDisabledSubmit()
  })

  $(formId).on('click', 'textarea', function (e) {
    clearDisabledSubmit()
  })

  $(`${formId} select`).change(function () {
    clearDisabledSubmit()
  })
}

$('input').attr({ autocomplete: "off" });

function submitLoadableForm(formIdentifier = '.loadable-form', block = function () { }) {
  $(formIdentifier).submit(function (e) {
    block();
    $('#spinner-modal').modal('show');
    $(formIdentifier).submit();
  });
}

window.csrfToken = function () {
  const token = document.querySelector('meta[name="csrf-token"]').content

  return token
}

$(document).ready(function () {
  //Use this inside your document ready jQuery 
  $(window).on('popstate', function () {
    location.reload(true);
  });

  $('.hoe-has-menu').click(function () {
    if ($(this).hasClass('opened')) {
      $(this).removeClass('opened')
    } else {
      $(this).addClass('opened')
    }
  })

  $('.loadable-link').click(function () {
    $('#spinner-modal').modal('show');
  })

  // $(formId).submit(function(e){
  //   $('#spinner-modal').modal('show');
  //   $(formId).submit();
  // });

  const formArr = [
    '#add-role-form',
    '.general-form'];
  formArr.forEach(function (value, index) {
    submitLoadableForm(value)
  })

  if ($('.basic-select').length > 0) {
    $('.basic-select').select2()
  }

  if ($('.basic-select-modal').length > 0) {
    $('.basic-select-modal').select2({
      dropdownParent: $('#adjustment-modal')
    })
  }

  $('.delete-btn').click((e) => {
    e.preventDefault();

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success btn-sm',
        cancelButton: 'btn btn-danger btn-sm'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          type: "DELETE",
          url: e.target.href,
          headers: {
            'X-CSRF-Token': csrfToken()
          },
          data: {},
          dataType: "json",
          success: function (data) {
            if (data.error !== undefined) {
              window.location.replace('/');

              return
            }

            window.location.replace(e.target.dataset.redirectUrl);

            swalWithBootstrapButtons.fire(
              'Deleted!',
              'Successfully Deleted.',
              'success'
            )

          },
          error: function (data) {
            console.log('An error occurred.');
            console.log(data);
          },
        });


      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire(
          'Cancelled',
          'Not Deleted :)',
          'error'
        )
      }
    })
  })

  if ($('.basic-datatable').length > 0) {
    let table = new DataTable('.basic-datatable', {
      responsive: true
    });
  }
});
